module.exports = __webpack_public_path__ + "media/images/hamburger-5ed4bb3ea69206ae2c0fb00cbca4ac35.png";